<div class="page-container">
    <div class="form-card">
        <div class="form-header">
            <div class="header-left">
                <a routerLink="/users" class="btn-back">
                    <i class="fa fa-arrow-left"></i> Back
                </a>
                <h2>{{ isEditMode ? 'Edit User' : 'Create New User' }}</h2>
            </div>
        </div>

        <form [formGroup]="userForm" (ngSubmit)="onSubmit()">

            <div class="form-group">
                <label for="email">Email</label>
                <input id="email" type="email" formControlName="email" placeholder="Email address"
                    [class.invalid]="userForm.get('email')?.invalid && userForm.get('email')?.touched">
            </div>

            <div class="form-row">
                <div class="form-group half">
                    <label for="firstName">First Name</label>
                    <input id="firstName" type="text" formControlName="firstName" placeholder="First Name">
                </div>
                <div class="form-group half">
                    <label for="lastName">Last Name</label>
                    <input id="lastName" type="text" formControlName="lastName" placeholder="Last Name">
                </div>
            </div>

            <div class="form-group" *ngIf="!isEditMode">
                <label for="password">Password</label>
                <input id="password" type="password" formControlName="password" placeholder="Password"
                    [class.invalid]="userForm.get('password')?.invalid && userForm.get('password')?.touched">
            </div>

            <div class="form-group toggle-group">
                <label class="toggle-switch">
                    <input type="checkbox" formControlName="isActive">
                    <span class="slider"></span>
                </label>
                <div class="toggle-label">
                    <span class="label-text">Active User</span>
                    <p class="help-text">Inactive users cannot log in to the system</p>
                </div>
            </div>

            <div class="form-group" style="margin-top: 1.5rem;">
                <label>User Role <span class="text-danger">*</span></label>
                <div class="role-selector-container"
                    [class.invalid-border]="userForm.get('role')?.invalid && userForm.get('role')?.touched">
                    <div *ngIf="availableRoles.length === 0" class="no-roles-message">
                        No roles available to select.
                    </div>
                    <div *ngFor="let r of availableRoles" class="role-card"
                        [class.selected]="userForm.get('role')?.value === r"
                        (click)="userForm.get('role')?.setValue(r); userForm.get('role')?.markAsTouched()">
                        <span class="role-name">{{ r }}</span>
                        <div class="selection-indicator">
                            <i class="fa fa-check"></i>
                        </div>
                    </div>
                </div>
                <div *ngIf="userForm.get('role')?.invalid && userForm.get('role')?.touched" class="error-message">
                    Please select a user role.
                </div>
            </div>

            <div class="form-group" style="margin-top: 2rem;">
                <h3>Working Schedule</h3>
                <p class="help-text">Define working days and hours for this employee.</p>

                <div class="schedule-grid" formArrayName="schedules">
                    <div *ngFor="let schedule of schedulesArray.controls; let i = index" [formGroupName]="i"
                        class="schedule-row">
                        <div class="day-col">
                            <label class="checkbox-label">
                                <input type="checkbox" formControlName="isWorkingDay">
                                <span>{{ daysOfWeek[schedule.get('dayOfWeek').value] }}</span>
                            </label>
                        </div>
                        <div class="time-col">
                            <input type="time" formControlName="startTime"
                                [attr.disabled]="!schedule.get('isWorkingDay').value ? '' : null">
                            <span class="separator">-</span>
                            <input type="time" formControlName="endTime"
                                [attr.disabled]="!schedule.get('isWorkingDay').value ? '' : null">
                        </div>
                    </div>
                </div>
            </div>

            <button type="submit" [disabled]="userForm.invalid || isLoading" class="btn-primary">
                <span *ngIf="!isLoading">{{ isEditMode ? 'Update User' : 'Create User' }}</span>
                <span *ngIf="isLoading">Saving...</span>
            </button>

            <div *ngIf="errorMessage" class="error-alert">
                {{ errorMessage }}
            </div>
        </form>
    </div>
</div>